"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yearDayDiff = exports.monthDiffYearsDaysDiff = exports.monthDaysDiff = exports.daysInLastUTCDecade = exports.daysInLastUTCYear = exports.daysInNextUTCMonth = exports.daysInThisUTCMonth = exports.daysInLastUTCMonth = exports.timestampToYMDHMS = exports.getUTCDayHour = exports.getStdDay = exports.getEngDay = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const constants_1 = require("../../constants");
const TimeBuckets_1 = require("./Periodization/TimeBuckets");
const getEngDay = (stdDayNumber) => Object.values(iotv_v3_types_1.ENG_DAYS)[stdDayNumber];
exports.getEngDay = getEngDay;
const getStdDay = (engDay) => Object.values(iotv_v3_types_1.ENG_DAYS).findIndex((day) => day === engDay);
exports.getStdDay = getStdDay;
const getUTCDayHour = ({ tzOffset, day, hour }) => {
    const baseDate = new Date();
    const baseDay = baseDate.getUTCDay();
    baseDate.setUTCDate(baseDate.getUTCDate() + ((0, exports.getStdDay)(day) - baseDay));
    baseDate.setUTCHours(Math.round(hour - tzOffset));
    return { tzOffset: 0, day: (0, exports.getEngDay)(baseDate.getUTCDay()), hour: baseDate.getUTCHours() };
};
exports.getUTCDayHour = getUTCDayHour;
const timestampToYMDHMS = (timestamp) => {
    const localDate = new Date(timestamp);
    const [y, m, d, h, min, s] = [
        localDate.getUTCFullYear(),
        localDate.getUTCMonth(),
        localDate.getUTCDate(),
        localDate.getUTCHours(),
        localDate.getUTCMinutes(),
        localDate.getUTCSeconds(),
    ];
    return [y, m, d, h, min, s];
};
exports.timestampToYMDHMS = timestampToYMDHMS;
const daysInLastUTCMonth = (timestamp) => {
    const date = new Date(timestamp);
    date.setUTCDate(0);
    return date.getUTCDate();
};
exports.daysInLastUTCMonth = daysInLastUTCMonth;
const daysInThisUTCMonth = (timestamp) => {
    const date = new Date(timestamp);
    date.setUTCMonth(date.getUTCMonth() + 1, 0);
    return date.getUTCDate();
};
exports.daysInThisUTCMonth = daysInThisUTCMonth;
const daysInNextUTCMonth = (timestamp) => {
    const date = new Date(timestamp);
    date.setUTCMonth(date.getUTCMonth() + 2, 0);
    return date.getUTCDate();
};
exports.daysInNextUTCMonth = daysInNextUTCMonth;
const daysInLastUTCYear = (timestamp) => {
    const current = new Date(timestamp);
    const oneYear = new Date(current);
    oneYear.setUTCFullYear(oneYear.getUTCFullYear() - 1, current.getUTCMonth(), current.getUTCDate());
    const days = (current.valueOf() - oneYear.valueOf()) / constants_1.Milliseconds.DAY;
    return days;
};
exports.daysInLastUTCYear = daysInLastUTCYear;
const daysInLastUTCDecade = (timestamp) => {
    const current = new Date(timestamp);
    const oneDecade = new Date(current);
    oneDecade.setUTCFullYear(oneDecade.getUTCFullYear() - 10, current.getUTCMonth(), current.getUTCDate());
    const days = (current.valueOf() - oneDecade.valueOf()) / constants_1.Milliseconds.DAY;
    return days;
};
exports.daysInLastUTCDecade = daysInLastUTCDecade;
const monthDaysDiff = (accessorMonth, currentMonth, referenceYearTimestamp) => {
    let daysTotal = 0;
    const multiplier = accessorMonth - currentMonth >= 0 ? 1 : -1;
    const startMonth = Math.min(accessorMonth, currentMonth);
    const endMonth = Math.max(accessorMonth, currentMonth);
    let evaluatedMonth = startMonth;
    while (evaluatedMonth !== endMonth) {
        const monthDate = new Date(referenceYearTimestamp);
        monthDate.setUTCMonth(evaluatedMonth, 1);
        daysTotal += (0, exports.daysInThisUTCMonth)(monthDate.valueOf());
        evaluatedMonth++;
    }
    return daysTotal * multiplier;
};
exports.monthDaysDiff = monthDaysDiff;
const monthDiffYearsDaysDiff = (accessorYear, accessorMonth, currentYear, currentMonth) => {
    let daysTotal = 0;
    const rdx = [12, 31];
    const multiplier = (0, TimeBuckets_1.comparableProductOf)([accessorYear, accessorMonth], rdx) > (0, TimeBuckets_1.comparableProductOf)([currentYear, currentMonth], rdx) ? 1 : -1;
    const [startYear, startMonth] = multiplier === 1 ? [currentYear, currentMonth] : [accessorYear, accessorMonth];
    const [endYear, endMonth] = multiplier === 1 ? [accessorYear, accessorMonth] : [currentYear, currentMonth];
    let evaluatedMonth = new Date();
    evaluatedMonth.setUTCFullYear(startYear, startMonth, 1);
    // console.log({eval: evaluatedMonth.toUTCString(), startYear, startMonth, endYear, endMonth })
    while (!(evaluatedMonth.getUTCFullYear() === endYear && evaluatedMonth.getUTCMonth() === endMonth)) {
        daysTotal += (0, exports.daysInThisUTCMonth)(evaluatedMonth.valueOf());
        evaluatedMonth.setUTCMonth(evaluatedMonth.getUTCMonth() + 1);
        // console.log({eval: evaluatedMonth.toUTCString(), startYear, startMonth, endYear, endMonth })
    }
    return daysTotal * multiplier;
};
exports.monthDiffYearsDaysDiff = monthDiffYearsDaysDiff;
const yearDayDiff = (accessorYear, currentYear, referenceYearTimestamp) => {
    let daysTotal = 0;
    const multiplier = accessorYear - currentYear >= 0 ? 1 : -1;
    const startYear = Math.min(accessorYear, currentYear);
    const endYear = Math.max(accessorYear, currentYear);
    let evaluatedYear = startYear;
    while (evaluatedYear !== endYear) {
        const YearDate = new Date(referenceYearTimestamp);
        YearDate.setUTCFullYear(evaluatedYear, 1, 1);
        daysTotal += (0, exports.daysInLastUTCYear)(YearDate.valueOf());
        evaluatedYear++;
    }
    return daysTotal * multiplier;
};
exports.yearDayDiff = yearDayDiff;
